import { pushToDataLayer } from '@src/services/gtmService';
import storageService from '@src/services/storage-service';
import { getUrlPath } from '@src/utils/url-utils/url-utils';
import { useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

export default function NavigationTracker() {
    useEffect(() => {
        storageService.localStorage.set('isLandingPageVisit', 'true');
    }, []);

    // Track first ever visit
    const firstEverVisitPath = storageService.localStorage.get('firstEverVisitPath');
    if (!firstEverVisitPath) {
        window.isFirstEverVisit = true;
        storageService.localStorage.set('firstEverVisitPath', getUrlPath());
    }

    const isFirstPathChangeUpdate = useRef(true);
    const location = useLocation();

    const onPathChange = useCallback(() => {
        // Skip first route change
        if (isFirstPathChangeUpdate.current) {
            isFirstPathChangeUpdate.current = false;
            return;
        }

        storageService.localStorage.set('isLandingPageVisit', 'false');
    }, []);

    useEffect(() => {
        onPathChange();

        // Track page view of internal pages
        const shouldTrackPageView = location.pathname.startsWith('/bbs') || location.pathname.includes('/author/') || location.pathname.includes('/admin-settings/');
        if (shouldTrackPageView) pushToDataLayer({ event: 'non__article_view', path: location.pathname });
    }, [location.pathname]);

    return null;
}
